import React, { useState, useEffect, useContext, useMemo } from "react";
import _ from "lodash";
import axios from "axios";
import { makeStyles, withStyles } from "@mui/styles";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Select from "@mui/material/Select";
import Switch from "@mui/material/Switch";
import ActionPlansContext from "context/ActionPlansContext";
import ActionContext from "context/ActionContext";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import styled from "styled-components";
import UserService from "services/UserService";
import { getActionTURPE } from "services/ConfigServices";
import {
  calculateTurpeEco,
  optimizePsous,
} from "utilities/fonctionsturpe.js";
import Slider from "@mui/material/Slider";
import UploadMetersDialog from "./ElectricityMetersList/UploadMetersDialog";
//import useActionTable from "../useActionTable.js";

const FilterButton = styled.div`
  margin-right: 15px;
  &:hover {
    cursor: pointer;
  }
`;

const UploadButton = styled.div`
  &:hover {
    cursor: pointer;
  }
`;

const TableName = styled.div`
  margin-right: auto;
  margin-left: -8px;
  font-size: 1.3rem;
  font-weight: 500;
`;

function valuetext(value) {
  return `${value}%`;
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#fff',
    display: "flex",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    color: "rgba(0, 0, 0, 0.54)",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {},
}));

const GreenSwitch = withStyles((theme) => ({
  root: {
    width: 38,
    height: 22,
    padding: 0,
    margin: "4px 8px",
  },
  switchBase: {
    padding: 1,
    "&$checked": {
      transform: "translateX(16px)",
      color: '#fff',
      "& + $track": {
        backgroundColor: "#91C73C",
        opacity: 1,
        border: "none",
      },
    },
    "&$focusVisible $thumb": {
      color: "#91C73C",
      border: "6px solid #fff",
    },
  },
  thumb: {
    width: 20,
    height: 20,
  },
  track: {
    borderRadius: 26 / 2,
    border: `1px solid ${'#bdbdbd'}`,
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"]),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  );
});

const marks = [
  {
    value: 0,
    label: "0%",
  },
  {
    value: 100,
    label: "100%",
  },
];

const PrettoSlider = withStyles({
  root: {
    color: "#91C73C",
  },
  thumb: {
    height: 24,
    width: 24,
    backgroundColor: "#fff",
    border: "2px solid currentColor",
    marginTop: -8,
    marginLeft: -12,
    "&:focus, &:hover, &$active": {
      boxShadow: "inherit",
    },
  },
  active: {},
  valueLabel: {
    left: "calc(-50% + 4px)",
  },
  track: {
    height: 8,
    borderRadius: 4,
  },
  rail: {
    height: 8,
    borderRadius: 4,
  },
  markLabel: {
    top: "26px",
    color: "rgba(0, 0, 0, 0.54)",
    position: "absolute",
    fontSize: "13px",
    transform: "translateX(-50%)",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: 1.43,
    whiteSpace: "nowrap",
    letterSpacing: "0.01071em",
  },
  marked: {
    marginTop: "-3.5px",
    marginBottom: "4px",
  },
})(Slider);

export default function useActionTable() {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const actionplanupdate = permis.includes("actionplan_update");
  const [totalRows, setTotalRows] = useState(0);
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const appContext2 = useContext(ActionContext);
  const { action, setAction } = appContext2;
  const [recFTAEnabled, setRecFTAEnabled] = useState(
    action.parameters?.impact?.recFTAEnabled || false
  );

  const [structureData, setStructureData] = useState([]);

  const refreshTable = () => {
    let meters = action.parameters?.impact?.meters || [];

    setStructureData(meters);
  };

  useEffect(() => {
    let meters = action.parameters?.impact?.meters || [];
    setStructureData(meters);
  }, [JSON.stringify(action.parameters?.impact?.meters)]);

  const UploadComponent = ({ onUpload }) => (
    <UploadButton type="button" onClick={onUpload}>
      <UploadMetersDialog
        onClick={onUpload}
        refetch={refreshTable}
        //setLoading={setLoading}
      />
    </UploadButton>
  );

  const handleSwitchChange = async () => {
    let meters = action.parameters?.impact?.meters || [];
    recFTAEnabled
      ? meters.map((meter) => {
          meter.details.recFTAEnabled = false;
          optimizePsous(meter.details);
          //calculateFTAOptimization(meter.details, false);
          calculateTurpeEco(meter.details, false);
        })
      : meters.map((meter) => {
          meter.details.recFTAEnabled = true;
          optimizePsous(meter.details);
        //  calculateFTAOptimization(meter.details, true);
          calculateTurpeEco(meter.details, true);
        });
    setStructureData(meters);
    setRecFTAEnabled(!recFTAEnabled);
    setAction((prevState) => ({
      ...prevState,
      parameters: {
        ...prevState.parameters,
        impact: {
          ...prevState.parameters?.impact,
          recFTAEnabled: !recFTAEnabled,
        },
      },
    }));
  };

  const handleSliderChange = async (event, value) => {
    let meters = action.parameters?.impact?.meters;
    let margin = Number((value * 0.01 + 1).toFixed(2));
    meters.map((x) => (x.details.margin = margin));
    recFTAEnabled
      ? meters.map((meter) => {
          optimizePsous(meter.details);
         // calculateFTAOptimization(meter.details, true);
          calculateTurpeEco(meter.details, true);
        })
      : meters.map((meter) => {
          optimizePsous(meter.details);
        //  calculateFTAOptimization(meter.details, false);
          calculateTurpeEco(meter.details, false);
        });

    setAction((prevState) => ({
      ...prevState,
      parameters: {
        ...prevState.parameters,
        impact: {
          ...prevState.parameters?.impact,
          metersMargin: margin,
          meters,
        },
      },
    }));
  };

  const classes = useStyles();

  const SubHeaderComponent = () => {
    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={6} lg={5}>
          <TableName>Périmètre d&apos;optimisation</TableName>
        </GridItem>

        {actionplanupdate && (
          <>
            <GridItem xs={12} sm={12} md={6} lg={2}>
              <>
                <div
                  style={{
                    fontSize: "13px",
                    opacity: "0.8",
                    fontFamily: "Source Sans Pro,sans-serif",
                  }}
                >
                  FTA Recommandée
                </div>
                <div className={classes.switch}>
                  <FormControlLabel
                    control={
                      <GreenSwitch
                        checked={recFTAEnabled}
                        onChange={handleSwitchChange}
                      />
                    }
                  />
                </div>
              </>
            </GridItem>
            <GridItem xs={12} sm={12} md={6} lg={2}>
              <div
                style={{
                  fontSize: "13px",
                  opacity: "0.8",
                  fontFamily: "Source Sans Pro,sans-serif",
                }}
              >
                Marge de sécurité
              </div>
              <PrettoSlider
                defaultValue={(
                  (action.parameters?.impact?.metersMargin? (action.parameters?.impact?.metersMargin - 1) : 0) *
                  100
                ).toFixed(2)}
                getAriaValueText={valuetext}
                aria-labelledby="discrete-slider-small-steps"
                step={1}
                min={0}
                max={100}
                valueLabelDisplay="auto"
                marks={marks}
                onChangeCommitted={handleSliderChange}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={6} lg={3}>
              <UploadComponent key="UploadComponent" />
            </GridItem>
          </>
        )}
      </GridContainer>
    );
  };

  return {
    gridState: {
      defaultPageSize: 10,
      data: structureData,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      //title: headerComponentMemo,
      subHeaderComponent: <SubHeaderComponent />,
    },
    refreshTable,
  };
}
